import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class SuspendProtectionActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  public canRunForMultipleItems = false;
  public canRunOnMultipleCompanies = false;
  public canRunOnDefaultFolders = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    let canPerformAction;
    switch (true) {
      case ProtectedEntitiesHelper.isNetworkCollectionOrFolder(record):
        canPerformAction = false;
        break;
      case !ProtectedEntitiesHelper.isManaged(record):
        canPerformAction = false;
        break;
      case ProtectedEntitiesHelper.isSva(record):
        canPerformAction = false;
        break;
      default:
        canPerformAction = true;
        break;
    }
    return canPerformAction;
  }
}
